/**
 * Behavior
 * @param name
 * @constructor
 */
export const Behavior = (name: any) => {
    return (proto: any) => {
        try {
            // @ts-ignore
            if (!elementBehaviors.has(name)) {
                // @ts-ignore
                elementBehaviors.define(name, proto);
            }
        } catch(e) {
            console.log("elementBehaviors not loaded, possibly you are in test environment!");
        }
    };
}
